import script from "./yawGauge.vue?vue&type=script&setup=true&lang=js"
export * from "./yawGauge.vue?vue&type=script&setup=true&lang=js"

import "./yawGauge.vue?vue&type=style&index=0&id=5fb4d944&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fb4d944"]])

export default __exports__